'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Advertisement = require('./Advertisement');

var _Advertisement2 = _interopRequireDefault(_Advertisement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Advertisement2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/dist/commonjs/views/Advertisement/index.js
 ** module id = 3919
 ** module chunks = 0
 **/